const styles = `:host .control {
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  cursor: pointer;
  height: 28px;
  display: flex;
  outline: 0;
  color: var(--goto-text-02);
  align-items: center;
  justify-content: center;
  border-color: var(--goto-toolbar-background-color);
  background-color: var(--goto-toolbar-background-color);
  position: relative;
  border-bottom-left-radius: var(--goto-toolbar-button-left-radius, 0);
  border-top-left-radius: var(--goto-toolbar-button-left-radius, 0);
  border-bottom-right-radius: var(--goto-toolbar-button-right-radius, 0);
  border-top-right-radius: var(--goto-toolbar-button-right-radius, 0);
  padding: 0 8px;
}
:host .control .start {
  --goto-icon-color: design-token(icon-04);
  margin: 0 6px 0 0;
}
:host .control:hover {
  border-color: var(--goto-toolbar-hover-background-color);
  background-color: var(--goto-toolbar-hover-background-color);
}
:host .control:active {
  border-color: var(--goto-toolbar-pressed-background-color);
  background-color: var(--goto-toolbar-pressed-background-color);
  box-shadow: none;
  color: var(--goto-text-06);
}
:host .control:active .start {
  --goto-icon-color: design-token(text-06);
}
:host .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([selected]) .control {
  color: var(--goto-text-06);
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-interactive-01);
}
:host([selected]) .control .start {
  --goto-icon-color: design-token(icon-02);
}

:host([disabled]) .control {
  pointer-events: none;
  border-color: transparent;
  background-color: var(--goto-toolbar-disabled-background-color);
  color: var(--goto-toolbar-disabled-icon-color);
}
:host([disabled]) .control .start {
  --goto-icon-color: design-token(icon-04);
}

:host(.empty-content) .start {
  margin-right: 0;
}`; export default styles;